import { Switch } from "react-router";
import React from "react";

export const AuthBoundarySwitch: React.FC = ({ children }) => {
  // FIXME: 今後もしdinii forをもっと使うことがあれば，ここにログインハンドリングを記述したい
  return <Switch>{children}</Switch>;
};
